import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// Subscription
export const getSubscriptionList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.SUB_MAST_SUB_LIST_API);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getSubscriptionListActive = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.SUB_LIST_API);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getSubscriptionById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.SUB_MAST_GET_SUB_BY_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateSubscription = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.SUB_MAST_SUB_UPDATE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const buySubscriptionPlan = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.SUB_PLAN_BUY_API, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getActiveSubscriptionById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.SUB_DETAILS_BY_USER_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const submitSubscriptionEnquiry = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.SUB_PLAN_ENQUIRY_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const subscribeNewsletter = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.SUBSCRIBE_NEWSLETTER_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getActiveSubscriptionEnquiry = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(`${apiendpoints.GET_ADMIN_SUB_ENQ}`);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateSubscriptionEnquiryStatus = async (id, isApproved) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.UPDATE_ADMIN_SUB_ENQ}?id=${id}&isApproved=${isApproved}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
